<article class="w-full">
  <!-- <div class="flex flex-row items-center gap-4">
    <button class="primary-btn my-4" (click)="addNewCompany()">Add Company</button>
  </div> -->

  <!-- TABLE -->
  <section class="grid grid-cols-1 gap-4">
    <div class="col-span-1 overflow-hidden rounded-2xl border border-gray-300 bg-white">
      <div class="w-full overflow-x-auto">
        <mat-table
          [dataSource]="dataSource"
          matSort
          class="!inline-table !w-full min-w-[760px] table-fixed table-alternate text-sm"
        >
          <!-- ID COLUMN -->
          <ng-container matColumnDef="ID">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="w-[110px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
            >
              ID
            </th>

            <td
              mat-cell
              *matCellDef="let element"
              class="w-[110px] whitespace-nowrap px-5 py-5 text-sm font-medium text-gray-800"
            >
              {{ element.ID }}
            </td>
          </ng-container>

          <!-- COMPANY COLUMN -->
          <ng-container matColumnDef="Company">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
            >
              Company
            </th>

            <td
              mat-cell
              *matCellDef="let element"
              class="px-5 py-5"
            >
              <div class="max-w-[420px] overflow-hidden">
                <p class="truncate text-sm font-semibold leading-6 text-gray-900">
                  {{ element.Name }}
                </p>
              </div>
            </td>
          </ng-container>

          <!-- ACTIONS COLUMN -->
          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="actions-center w-[240px] whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
            >
              Actions
            </th>

            <td
              mat-cell
              *matCellDef="let element"
              class="actions-center w-[240px] whitespace-nowrap px-5 py-5"
            >
              <div class="actions-wrap flex w-full items-center justify-center gap-1">
                <button
                  mat-icon-button
                  (click)="editCompany(element)"
                  matTooltip="Edit"
                  matTooltipPosition="above"
                  class="transition-colors hover:text-blue-600"
                >
                  <mat-icon>edit</mat-icon>
                </button>

                <button
                  mat-icon-button
                  (click)="openDeleteCompanyConfirm(element)"
                  matTooltip="Delete"
                  matTooltipPosition="above"
                  class="transition-colors hover:text-red-600"
                >
                  <mat-icon>delete</mat-icon>
                </button>

                <button
                  mat-icon-button
                  (click)="viewcopmanysettings(element)"
                  matTooltip="Settings"
                  matTooltipPosition="above"
                  class="transition-colors hover:text-gray-900"
                >
                  <mat-icon>settings</mat-icon>
                </button>

                <button
                  mat-icon-button
                  matTooltip="Preview Index"
                  (click)="viewCompanyProfile(element)"
                  matTooltipPosition="above"
                  class="transition-colors hover:text-indigo-600"
                >
                  <mat-icon>pageview</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <!-- HEADER AND ROW DEFINITIONS -->
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="border-b border-gray-300 bg-gray-50"
          >
          </tr>

          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            class="border-b border-gray-100 bg-white transition-colors even:bg-gray-50/40 hover:bg-gray-100"
          >
          </tr>
        </mat-table>
      </div>
    </div>

    <!-- PAGINATOR -->
    <div class="col-span-1 overflow-hidden rounded-2xl border border-gray-300 bg-white">
      <mat-paginator
        [length]="totalItems"
        [pageSize]="12"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </section>

  <!-- TEMPLATES -->
  <ng-template #companyFormTmpl>
    <app-company-form
      [formData]="selectedCompany"
      (onSubmitClbk)="onSubmitCompanyClbk()"
    >
    </app-company-form>
  </ng-template>

  <ng-template #confirmDeleteTmpl>
    <div class="flex flex-col gap-4">
      <p>Are you sure you want to delete <b>{{ selectedCompany.Name }}</b>?</p>

      <div class="flex flex-row items-center justify-center gap-2">
        <button class="base-btn" (click)="deleteCompany()">Confirm</button>
        <button class="base-btn" (click)="dialog.closeAll();">Cancel</button>
      </div>
    </div>
  </ng-template>
</article>